import Cookie from "js-cookie";
import styles from "./CookieConsentDeclineButton.module.css";

export default function CookieConsentDeclineButton(): JSX.Element {
  const rejectCookiez = () => {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(
      cookieExpirationDate.getTime() + 7 * 24 * 60 * 60 * 1000
    ); // 7 days
    Cookie.set("cookiePolicy", JSON.stringify({ cookiesEnables: false }), {
      path: "/",
      expires: cookieExpirationDate,
      sameSite: "Strict",
    });
  };
  return (
    <div
      data-icon-only="No"
      data-icon="No"
      data-size="Medium"
      data-state="Default"
      data-type="Secondary"
      className={styles.button}
      role="button"
      tabIndex={0}
      onKeyDown={() => {
        // localStorage.setItem("acceptedCookies", "false");
        rejectCookiez();
      }}
      onClick={() => {
        rejectCookiez();
        // localStorage.setItem("acceptedCookies", "false");
      }}
    >
      <div className={styles.text}>Decline</div>
    </div>
  );
}
